/**
 * Changes the input field of the form
 *
 * @param  {form} form The new text of the input field
 *
 * @return {object}    An action object with a type of CHANGE_USERNAME
 */
import {
  SAVE,
  VALUE_CHANGED,
  LOAD,
  NEXT,
  RESET,
  RESET_ADDRESS,
  SET_PAYMENT_TYPE_OPTIONS,
} from './constants';

export function saveFormData(form) {
  return {
    type: SAVE,
    payload: form,
  };
}

export function loadFormData(form) {
  return {
    type: LOAD,
    payload: form,
  };
}

export function handleFormDataChange(propertyName, value) {
  return {
    type: VALUE_CHANGED,
    propertyName,
    value,
  };
}

export function nextSlide(errors) {
  return {
    type: NEXT,
    errors,
  };
}

export function resetFormData() {
  return {
    type: RESET,
  };
}

export function resetFormDataAddress() {
  return {
    type: RESET_ADDRESS,
  };
}

export function setPaymentTypeOptions(propertyName, value) {
  return {
    type: VALUE_CHANGED,
    propertyName,
    value,
  };
}



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepPaymentDetails/actions.js